import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AlertField from "../Components/AlertField";
import useAuth from "../Hooks/useAuth";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const ReviewForm = () => {
  const { auth } = useAuth();
  const [alert, setAlert] = useState(null);
  const [doctor, setDoctor] = useState({});
  const [values, setValues] = useState({
    to: "System",
    review_by: auth?.user?.id,
    doctor: "",
    description: "",
  });

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const onChange = (e) => {
    //setting the doctor to null if patient choses system
    if (e.target.value === "System") {
      values["doctor"] = "";
    }
    if (e.target.value !== "Choose Doctor") {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  useEffect(() => {
    const fetchDoctor = async () => {
      try {
        const response = await axiosPrivate.get("user/doctor/");
        setDoctor(response.data);
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else {
          showAlert("Load Failed", "warning");
        }
      }
    };
    fetchDoctor();
  }, []);

  const onClick = async () => {
    //checks if feedback is given or not
    if (values?.description === "") {
      showAlert("Give your feedback.", "warning");
    } else {
      //checks if doctor is chosen its name is also chosen
      if (
        (values?.to === "Doctor" && values?.doctor !== "") ||
        values?.to === "System"
      ) {
        try {
          await axiosPrivate.post("review/", values);
          navigate("/list/review", {
            state: {
              message: "We will consider your valuable feedback.",
              type: "success",
            },
          });
        } catch (err) {
          if (!err?.response) {
            showAlert("No Server Response", "warning");
          } else if (err?.response.status === 400) {
            showAlert(err?.response.data?.message, "warning");
          } else {
            showAlert("Load Failed", "warning");
          }
        }
      } else {
        showAlert("Choose Doctor.", "warning");
      }
    }
  };

  return (
    <>
      <AlertField alert={alert} />

      <div className="bg-light text-center m-5 py-2 px-5">
        <h2 className="pt-2">Review Us</h2>
        <label className="w-100 fs-6 mt-0 mb-5">
          Provide us a genuine feedback so we can make our system much better
          and grow stronger.
        </label>
        <textarea
          name="description"
          placeholder="* Add your valuable feedback"
          id="description"
          className="w-50 p-4"
          rows="7"
          value={values?.description}
          onChange={onChange}
        ></textarea>
        <div
          className="d-flex justify-content-center w-100 mt-2"
          style={{ gap: 20 + "rem" }}
        >
          <div className="d-flex">
            <h4>To:</h4>
            <select
              className="mx-4 rounded px-2"
              name="to"
              id="to"
              value={values?.to}
              onChange={onChange}
            >
              <option value="System">System</option>
              <option value="Doctor">Doctor</option>
            </select>
          </div>
          {values?.to !== "System" && (
            <div className="d-flex">
              <h4>Doctor's Name:</h4>
              <select
                className="mx-4 rounded px-2"
                name="doctor"
                id="doctor"
                value={values?.doctor || ""}
                onChange={onChange}
              >
                <option value="Choose Doctor">Choose Doctor</option>
                {doctor.length > 0 &&
                  doctor.map((name, i) => (
                    <option value={name?.id} key={i}>
                      {name?.user_detail.name}
                    </option>
                  ))}
              </select>
            </div>
          )}
        </div>
        <button className="my-3 btn btn-primary" onClick={onClick}>
          Submit
        </button>
      </div>
    </>
  );
};

export default ReviewForm;
